// SPDX-FileCopyrightText: 2025 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export function useGetDocumentUrl() {
    var getImageUrl = function (tenantId, imageDocumentId, name) { return "tenant-".concat(tenantId, "/document-").concat(imageDocumentId, "/").concat(name); };
    return getImageUrl;
}
